import PropTypes from 'prop-types';

import Container from '@mui/material/Container';
import Link from '@mui/material/Link';

import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import { useIntl } from 'react-intl';
import { Copyright } from 'components/Copyright';
import * as React from 'react';
import Digitech from 'components/Logo/Digitech';
import { Stack } from '@mui/material';

function Footer({ light, aboutDisplayed }) {
  const { formatMessage: msg } = useIntl();

  const links = [
    {
      href: msg({ id: 'company.website' }),
      name: msg({ id: 'company.name' }),
      logo: <Digitech width="32" light={light} />
    }
  ];
  if (aboutDisplayed) {
    links.push({
      href: 'https://www.digitech.fr/digitech/cms/8/societe-digitech-editeur-et-integrateur.dhtml/',
      name: msg({ id: 'common.about' })
    });
  }

  const renderLinks = () =>
    links.map((link) => (
      <MDBox key={link.name} component="li" px={2} lineHeight={1}>
        <Link href={link.href} target="_blank">
          <Stack direction="row" spacing={1} justifyContent="center" alignItems="center">
            {link.logo}
            <MDTypography variant="button" fontWeight="regular" color={light ? 'white' : 'text'}>
              {link.name}
            </MDTypography>
          </Stack>
        </Link>
      </MDBox>
    ));

  return (
    <MDBox position="absolute" width="100%" bottom={0} py={4}>
      <Container disableGutters>
        <MDBox
          width="100%"
          display="flex"
          flexDirection={{ xs: 'column', lg: 'row' }}
          justifyContent="space-between"
          alignItems="center"
        >
          <MDBox
            component="ul"
            sx={({ breakpoints }) => ({
              display: 'flex',
              flexWrap: 'wrap',
              alignItems: 'center',
              justifyContent: 'center',
              listStyle: 'none',
              mt: 3,
              mb: 1,
              p: 0,
              [breakpoints.up('lg')]: {
                margin: 0
              }
            })}
          >
            {renderLinks()}
          </MDBox>
          <MDBox display="flex" justifyContent="center" alignItems="center" flexWrap="wrap">
            <Copyright light={light} />
          </MDBox>
        </MDBox>
      </Container>
    </MDBox>
  );
}

// Setting default props for the Footer
Footer.defaultProps = {
  light: false,
  aboutDisplayed: false
};

// Typechecking props for the Footer
Footer.propTypes = {
  light: PropTypes.bool,
  aboutDisplayed: PropTypes.bool
};

export default Footer;
